import script from "./customFieldRender.vue?vue&type=script&setup=true&lang=js"
export * from "./customFieldRender.vue?vue&type=script&setup=true&lang=js"

import "./customFieldRender.vue?vue&type=style&index=0&id=7cc08f17&lang=css"

const __exports__ = script;

export default __exports__